// DrivingSessionsGallery.jsx

import React, { useState, useEffect } from 'react';
import DrivingSession from './DrivingSession';
import { RingLoader } from 'react-spinners';
import ApiStore from '../../../api/ApiStore';
import { FiSearch } from 'react-icons/fi'; // Import the search icon

const DrivingSessionsGallery = () => {
  const [sessions, setSessions] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentSession, setCurrentSession] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const organizationName = 'Madel';

  // Define a list of cover images
  const coverImages = [
    '/driving_1.webp',
    '/driving_2.webp',
    '/driving_3.webp',
    '/driving_4.webp',
    '/driving_5.webp',
    '/driving_6.webp',
    '/driving_7.webp',
    '/driving_8.webp',
  ];

  useEffect(() => {
    const fetchSessions = async () => {
      try {
        setIsLoading(true);

        // Fetch sessions from the backend using ApiStore
        const sessionsData =
          await ApiStore.getStudentDrivingSessions(organizationName);

        // Transform the sessions data
        const transformedSessions = sessionsData.map(session => {
          // Select a random image from the coverImages array
          const randomImage =
            coverImages[Math.floor(Math.random() * coverImages.length)];

          return {
            session_id: session.DrivingSessionID,
            session_name: session.SessionName,
            description:
              session.Description ||
              'No description available. No description available.',
            backgroundImage: randomImage,
          };
        });

        setSessions(transformedSessions);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching sessions:', error);
        setIsLoading(false);
      }
    };

    fetchSessions();
  }, []);

  const openSession = session => {
    // Set the current session to the selected session
    setCurrentSession(session);
  };

  const filteredSessions = sessions.filter(session => {
    const matchesSearch = session.session_name
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    return matchesSearch;
  });

  if (currentSession) {
    // Render the DrivingSession component when a session is selected
    return (
      <div className="min-h-screen bg-gray-100 flex flex-col">
        <DrivingSession
          session={currentSession}
          onClose={() => setCurrentSession(null)}
        />
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen bg-gray-100">
        <RingLoader color="#000000" size={120} />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <div className="flex-grow p-8 max-w-6xl mx-auto">
        <h1 className="text-4xl font-bold mb-8 text-gray-800 text-center">
          Sesiones de Conducción
        </h1>
        <div className="mb-8 relative max-w-2xl mx-auto">
          <input
            type="text"
            placeholder="Buscar sesiones..."
            className="w-full p-4 pr-12 rounded-lg border-2 border-gray-300 focus:outline-none focus:border-blue-500 transition-colors"
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
          />
          <FiSearch className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-xl" />
        </div>
        {filteredSessions.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredSessions.map(session => (
              <div
                key={session.session_id}
                className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow cursor-pointer"
                onClick={() => openSession(session)}
              >
                <div
                  className="w-full h-48 relative"
                  style={{
                    backgroundImage: `url(${session.backgroundImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}
                >
                  {/* Optional Overlay */}
                  <div className="absolute inset-0 bg-black bg-opacity-30"></div>
                </div>
                <div className="p-6">
                  <h2 className="text-xl font-semibold mb-2 text-gray-800">
                    {session.session_name}
                  </h2>
                  <p className="text-sm text-gray-600">{session.description}</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center text-gray-600">
            No se encontraron sesiones.
          </p>
        )}
      </div>
    </div>
  );
};

export default DrivingSessionsGallery;
